//add all cities data
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_Campaign_Type,
  Delete_Campaign_Type,
  Get_All_Campaign_Type,
  Get_Campaign_Reports_Type,
  Get_Error,
  Get_One_Campaign_Type,
  Update_One_Campaign_Type,
} from '../Types';

export const Add_Campaign_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Campain`, body);

    dispatch({
      type: Add_Campaign_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetAllCampainData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Campain?campaignisactivatedelete=true`);

    dispatch({
      type: Get_All_Campaign_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all campaigns data not activate
export const GetAllCampainDatanotactivate = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Campain?campaignisactivatedelete=false`);

    dispatch({
      type: Get_All_Campaign_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one Area data
export const DeleteOneCampaignData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Campain/${id}`);

    dispatch({
      type: Delete_Campaign_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Area data
export const GetOnecampaignData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Campain/${id}`);

    dispatch({
      type: Get_One_Campaign_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one Area data
export const UpdateOneCampaignData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Campain/${id}`, body);

    dispatch({
      type: Update_One_Campaign_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get Campaign Reports data
export const GetCampainReportsData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/Campain/stage-campaign-report`);

    dispatch({
      type: Get_Campaign_Reports_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
